export function gain_produce(pid) {
	if (pid) {

		let temp_produce = false;
		for (let i in produce) {
			if (produce[i]['p_id'] === pid) {
				temp_produce = produce[i];
				break;
			}
		}

		switch (temp_produce['p_id']) {
			case 'pidnon_fb': {
				temp_produce['table'] = createPid_fb();
				break;
			}
		}

		return temp_produce;
	}
}

const produce = [
	{p_id:'pidnon_fb',  choose:false, p_name:'特殊产品'},
]

// 非标产品
function createPid_fb() {
	return {
		// 产品类型
		p_chanpinleixing: {
			name: '产品类型',
			container: 'hjg',
			data: [
			{ type: 'default', name: '信封', value: '信封', choose: true },
			{ type: 'default', name: '红包', value: '红包', choose: false },
			{ type: 'default', name: '文件袋', value: '文件袋', choose: false },
			{ type: 'default', name: '印刷加工', value: '印刷加工', choose: false },
			{ type: 'default', name: '后工加工', value: '后工加工', choose: false },
			{
					
				type: 'select', name: '房卡套', value: '房卡套', choose: false, select_show: false, select_data: [
			    { name: '房卡套', value: '房卡套' },
				{ name: '筷子套', value: '筷子套' },
				{ name: '封套', value: '封套' },
				{ name: '单张', value: '单张' },
				{ name: '联单', value: '联单' },
				{ name: '便笺表格', value: '便笺表格' },
				{ name: '档案盒', value: '档案盒' },
				{ name: '会计用品', value: '会计用品' },
				{ name: '标签', value: '标签' },
				]
					
			}
        /* {type:'default', name:'非标红包',   value:'非标红包',   choose:false},
        {type:'default', name:'非标文件袋', value:'非标文件袋', choose:false},
        {type:'default', name:'非标房卡套', value:'非标房卡套', choose:false},
        {type:'default', name:'非标筷子套', value:'非标筷子套', choose:false},
        {type:'default', name:'非标封套',   value:'非标封套',   choose:false},
        {type:'default', name:'非标宣传单', value:'非标宣传单', choose:false}, */
			],
	},

	// 印刷数量
		p_yinshuashuliang: {
			name: '订单数量',
			container: 'shuliang',
			data: [
				{type:'custom1',  name:' ',  value:0, unit:'', choose:true,},
			]
		},
		p_zhongliang: {
			name: '重量',
			container: 'iWeight',
			data: [
				{type:'custom1',  name:' ',  value:0, unit:'KG', choose:true,},
			]
		},
		p_kuaidifei: {
			name: '快递费',
			container: 'kuaidifei',
			data: [
				{type:'custom1',  name:' ',  value:'0', unit:'元', choose:true,},
			]
		},
	// 客服报价
	
		p_kefubaojia: {
			name: '客服报价',
			container: 'price',
			data: [
				{type:'custom1',  name:' ',  value:'0', unit:'元', choose:true,},
			]
		},
		
		// 订单备注
		p_dingdanbeizhu: {
			name: '订单备注',
			container: 'remark',
			data: [
				{type:'customT',  name:' ',  value:'', choose:true,},
			],
		},
	}
}



// WEBPACK FOOTER //
// ./src/seal/proNonStandard.js